import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: #3498DB;
	border-radius: 5px;
	color: white;
	display: inline-block;
	padding: 30px;
	text-align: center;
`;

export const Title = styled.h1`
	text-align: center;
`;